import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import { SITE } from "../lib/site";

const links = [
  { label: "Prestations", href: "#services" },
  { label: "Avis", href: "#reviews" },
  { label: "Bio", href: "#bio" },
  { label: "Série", href: "#serie" },
  { label: "Galerie", href: "#galerie" },
  { label: "Univers", href: "#universe" },
  { label: "Contact", href: "#contact" },
];

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-black/70 backdrop-blur-2xl border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="px-6 md:px-10 lg:px-16 py-4 flex items-center justify-between">
        <a
          href="#top"
          data-testid="header-logo"
          className="flex items-center gap-2 group"
        >
          <span className="w-9 h-9 rounded-full bg-gradient-to-br from-[#E9C766] via-[#D4AF37] to-[#8a6618] flex items-center justify-center text-black font-bold text-sm">
            AS
          </span>
          <div className="leading-tight">
            <div className="text-white font-semibold tracking-wide text-sm md:text-base">
              DJ AS Animation
            </div>
            <div className="text-[10px] md:text-xs uppercase tracking-[0.28em] text-zinc-400">
              Adrien Sebert
            </div>
          </div>
        </a>

        <nav className="hidden lg:flex items-center gap-6">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className="text-sm text-zinc-300 hover:text-[#D4AF37] transition-colors whitespace-nowrap"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <a
            href={`tel:${SITE.phoneInternational}`}
            data-testid="header-call-btn"
            className="text-sm text-zinc-300 hover:text-white flex items-center gap-2 px-3 py-2 rounded-full border border-white/10 hover:border-white/30 transition"
          >
            <Phone size={14} />
            {SITE.phoneDisplay}
          </a>
          <a
            href="#contact"
            data-testid="header-cta-quote"
            className="btn-gold rounded-full px-5 py-2.5 text-sm"
          >
            Demander un devis
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="lg:hidden text-white p-2"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-white/10 bg-black/90 backdrop-blur-xl">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`mobile-nav-${l.label.toLowerCase()}`}
                className="text-zinc-200 text-base"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="mobile-cta-quote"
              className="btn-gold rounded-full px-5 py-3 text-sm text-center mt-2"
            >
              Demander un devis
            </a>
            <a
              href={`tel:${SITE.phoneInternational}`}
              data-testid="mobile-call-btn"
              className="btn-outline-gold rounded-full px-5 py-3 text-sm text-center"
            >
              Appeler {SITE.phoneDisplay}
            </a>
          </div>
        </div>
      )}
    </header>
  );
};
